// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__3n61J","withMobileMargins":"DateRangeInput_withMobileMargins__Zr8Zi","arrowIcon":"DateRangeInput_arrowIcon__dZwQG"};